import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import api from "../../app/services/api";
import DocumentData from "./DocumentData";
import { useNavigate } from "react-router-dom";
import env from "react-dotenv";

const imageTypes = ["image/jpeg", "image/png", "image/gif"];

const DocumentDetails = () => {
  const { document_id } = useParams();
  const [currentDocument, setCurrentDocument] = useState(false);
  const [addKeywords, setKeywords] = useState([]);
  const [filePath, setFilePath] = useState([]);
  let navigate = useNavigate();
  useEffect(() => {
    api.get(`documents/${document_id}`).then((response) => {
      const { data } = response;
      const { data: document } = data;

      setCurrentDocument(document);
      setKeywords(document.keywords);
      setFilePath(`${env.UPLOADS_URL}/uploads/${document.name}`);
    });
  }, [document_id]);

  return (
    <>
      {currentDocument && (
        <>
          <div>{currentDocument.name} </div>
          {imageTypes.includes(currentDocument?.mime_type) ? (
            <img src={filePath} />
          ) : (
            <object
              data={filePath}
              type="application/pdf"
              width="100%"
              height="900px"
            >
              <p>
                Unable to display PDF file. <a href={filePath}>Download</a>{" "}
                instead.
              </p>
            </object>
          )}
          <DocumentData file={currentDocument} />
        </>
      )}
    </>
  );
};

export default DocumentDetails;
